import sms from "../assets/icons/sms.svg";
import googleRCS from "../assets/icons/googleRCS.svg";
import email from "../assets/icons/email.svg";
import voiceAPIs from "../assets/icons/voiceAPIs.svg";
import whatsApp from "../assets/icons/whatsApp.svg";
import BFSI from "../assets/icons/bfsi.svg";
import Hospitality from "../assets/icons/hospitality.svg";
import dthEntertainment from "../assets/icons/dthEntertainment.svg";
import retail from "../assets/icons/retail.svg";
import realestate from "../assets/icons/realestate.svg";
import education from "../assets/icons/education.svg";
import caseStudy01 from "../assets/images/casestudy01.png";
import caseStudy02 from "../assets/images/casestudy02.png";
import caseStudy03 from "../assets/images/casestudy03.png";
import Airtel from "../assets/images/Airtel.png";
import Ooredoo from "../assets/images/Ooredoo.png";
import Halotel from "../assets/images/Halotel.png";
import Truemove from "../assets/images/Truemove.png";
import AIS from "../assets/images/AIS.png";
import Dialog from "../assets/images/Dialog.png";
import Vodafone from "../assets/images/Vodafone.png";
import DU from "../assets/images/DU.png";
import Tigo from "../assets/images/Tigo.png";
import Roshan from "../assets/images/Roshan.png";
import Ncell_a from "../assets/images/Ncell_a.png";
import Ncell from "../assets/images/Ncell.png";
import Dtac from "../assets/images/Dtac.png";
import Vi from "../assets/images/Vi.png";
import zain from "../assets/images/zain.png";
import etisalat from "../assets/images/etisalat.png";
import Banglalink from "../assets/images/Banglalink.png";
import MTN from "../assets/images/MTN.png";
import mobile9 from "../assets/images/mobile9.png";
import Glo from "../assets/images/Glo.png";
import Telkomsel from "../assets/images/Telkomsel.png";
import Cipla from "../assets/images/Cipla.png";
import Abbott from "../assets/images/Abbott.png";
import Ceat from "../assets/images/Ceat.png";
import Britannia from "../assets/images/Britannia.png";
import Pepsi from "../assets/images/Pepsi.png";
import CocaCola from "../assets/images/CocaCola.png";
import Dabur from "../assets/images/Dabur.png";
import Nestle from "../assets/images/Nestle.png";
import Jktyre from "../assets/images/Jktyre.png";
import ITC from "../assets/images/ITC.png";
import Panasonic from "../assets/images/Panasonic.png";
import PandG from "../assets/images/PandG.png";
import Unilever from "../assets/images/Unilever.png";
import Samsung from "../assets/images/Samsung.png";
import WHO from "../assets/images/WHO.png";
import loyalty from "../assets/icons/loyalty.svg";
import tocom from "../assets/icons/tocom.svg";
import customer_connect from "../assets/icons/customer_connect.svg";
import UKFlag from "../assets/icons/ukFlag.svg";
import hrms from "../assets/icons/hrms.svg";
import thumbnail from "../assets/images/thumbnail.png";
import BFSI01 from "../assets/images/bfsi_01.png";
import BFSI02 from "../assets/images/bfsi_02.png";
import BFSI03 from "../assets/images/bfsi_03.png";
import BFSI04 from "../assets/images/bfsi_04.png";
import hospitalityPSdata01 from "../assets/images/hospitalityPSdata_01.png";
import hospitalityPSdata02 from "../assets/images/hospitalityPSdata_02.png";
import hospitalityPSdata03 from "../assets/images/hospitalityPSdata_03.png";
import hospitalityPSdata04 from "../assets/images/hospitalityPSdata_04.png";
import dthentertainmentsol01 from "../assets/images/dthentertainmentsol_01.png";
import dthentertainmentsol02 from "../assets/images/dthentertainmentsol_02.png";
import dthentertainmentsol03 from "../assets/images/dthentertainmentsol_03.png";
import dthentertainmentsol04 from "../assets/images/dthentertainmentsol_04.png";
import retail01 from "../assets/images/retail_01.png";
import retail02 from "../assets/images/retail_02.png";
import retail03 from "../assets/images/retail_03.png";
import retail04 from "../assets/images/retail_04.png";
import realestate01 from "../assets/images/realestate_01.png";
import realestate02 from "../assets/images/realestate_02.png";
import realestate03 from "../assets/images/realestate_03.png";
import realestate04 from "../assets/images/realestate_04.png";
import education01 from "../assets/images/education_01.png";
import education02 from "../assets/images/education_02.png";
import education03 from "../assets/images/education_03.png";
import education04 from "../assets/images/education_04.png";
import SMS from "../assets/images/sms.png";
import googlercs from "../assets/images/googlercs.png";
import emailchannels from "../assets/images/emailchannels.png";
import whatsapp from "../assets/images/whatsapp.png";
import voiceapis from "../assets/images/voiceapis.png";
import {
  CLOUD_TELEPHONY_URL,
  HRMS_URL,
  LOYALTY_URL,
  TOCOM_URL,
} from "../config";
import ACD_CaseStudy from "../assets/caseStudies/ACD_CaseStudy.pdf";
import HRMS_CaseStudy from "../assets/caseStudies/HRMS_CaseStudy.pdf";
import LOYALTY_CaseStudy from "../assets/caseStudies/Loyalty_CaseStudy.pdf";
import TOCOM_CaseStudy from "../assets/caseStudies/TOCOM_CaseStudy.pdf";
import credimate_CaseStudy from "../assets/caseStudies/credimate.pdf";
import hrms_CaseStudy from "../assets/caseStudies/hrms.pdf";
import hindware_CaseStudy from "../assets/caseStudies/hindware.pdf";
import lenskart_CaseStudy from "../assets/caseStudies/lenskart.pdf";
import { routePath } from "../routes/route";

export const brands = [
  {
    image: Airtel,
    name: "Airtel",
  },
  {
    image: Ooredoo,
    name: "Ooredoo",
  },
  {
    image: Halotel,
    name: "Halotel",
  },
  {
    image: Truemove,
    name: "Truemove",
  },
  {
    image: AIS,
    name: "AIS",
  },
  {
    image: Dialog,
    name: "Dialog",
  },
  {
    image: Vodafone,
    name: "Vodafone",
  },
  {
    image: Roshan,
    name: "Roshan",
  },
  {
    image: DU,
    name: "DU",
  },
  {
    image: Tigo,
    name: "Tigo",
  },
  {
    image: Ncell_a,
    name: "Ncell_a",
  },
  {
    image: Ncell,
    name: "Ncell",
  },
  {
    image: etisalat,
    name: "etisalat",
  },
  {
    image: Vi,
    name: "Vi",
  },
  {
    image: zain,
    name: "Zain",
  },
  {
    image: Dtac,
    name: "Dtac",
  },
  {
    image: Banglalink,
    name: "Banglalink",
  },
  {
    image: MTN,
    name: "MTN",
  },
  {
    image: mobile9,
    name: "9mobile",
  },
  {
    image: Glo,
    name: "Glo",
  },
  {
    image: Telkomsel,
    name: "Telkomsel",
  },
  {
    image: Cipla,
    name: "Cipla",
  },
  {
    image: Abbott,
    name: "Abbott",
  },
  {
    image: Ceat,
    name: "Ceat",
  },
  {
    image: Britannia,
    name: "Britannia",
  },
  {
    image: Pepsi,
    name: "Pepsi",
  },
  {
    image: CocaCola,
    name: "Coca Cola",
  },
  {
    image: Dabur,
    name: "Dabur",
  },
  {
    image: Nestle,
    name: "Nestle",
  },
  {
    image: Jktyre,
    name: "Jktyre",
  },
  {
    image: ITC,
    name: "ITC",
  },
  {
    image: Panasonic,
    name: "Panasonic",
  },
  {
    image: PandG,
    name: "P&G",
  },
  {
    image: Unilever,
    name: "Unilever",
  },
  {
    image: Samsung,
    name: "Samsung",
  },
  {
    image: WHO,
    name: "WHO",
  },
];

export const lang = [
  {
    flag: UKFlag,
    name: "EN",
  },
];

export const countryCodeList = ["+1", "+44", "+91"];

export const tabs = [
  { id: routePath.home.path, title: "Our Platforms" },
  {
    id: routePath.oursolutions.path,
    title: "Our solutions",
    innerTabs: [
      { id: "bfsi", name: "BFSI" },
      { id: "hospitality", name: "Hospitality" },
      { id: "retail", name: "Retail" },
      { id: "dthentertainment", name: "DTH & Entertainment" },
      { id: "realestate", name: "Real Estate" },
      { id: "education", name: "Education" },
      { id: "contactus", name: "Contact Us" },
    ],
  },
  {
    id: routePath.channels.path,
    title: "Channels",
    innerTabs: [
      { id: "sms", name: "SMS" },
      { id: "googlercs", name: "Google RCS" },
      { id: "whatsapp", name: "WhatsApp" },
      { id: "email", name: "Email" },
      { id: "voiceapis", name: "Voice APIs" },
      { id: "contactus", name: "Contact Us" },
    ],
  },
  { id: routePath.aboutus.path, title: "About Us" },
  {
    id: routePath.resources.path,
    title: "Resources",
    innerTabs: [
      { id: "blog", name: "Blog" },
      { id: "newsletter", name: "Newsletter" },
      { id: "casestudy", name: "Case Studies" },
      { id: "ebook", name: "Ebook" },
      { id: "videos", name: "Videos" },
      { id: "webinars", name: "Webinars" },
      { id: "contactus", name: "Contact Us" },
    ],
  },
  { id: routePath.subscription.path, title: "Subscription" },
];

export const footer = [
  {
    topic: "Product",
    links: [
      { id: LOYALTY_URL, name: "Loyalty", openInNewTab: true },
      { id: TOCOM_URL, name: "Tocom", openInNewTab: true },
      { id: CLOUD_TELEPHONY_URL, name: "Customer connect", openInNewTab: true },
      { id: HRMS_URL, name: "HRMS", openInNewTab: true },
    ],
  },
  {
    topic: "Industries",
    links: [
      { id: "oursolutions/bfsi", name: "BFSI" },
      { id: "oursolutions/hospitality", name: "Hospitality" },
      { id: "oursolutions/dthentertainment", name: "DTH & Entertainment" },
      { id: "oursolutions/retail", name: "Retail" },
      { id: "oursolutions/realestate", name: "Real Estate" },
      { id: "oursolutions/education", name: "Education" },
    ],
  },
  {
    topic: "Company",
    links: [
      { id: "aboutus", name: "About US" },
      { name: "News" },
      { name: "Careers" },
      { name: "Leadership" },
      { name: "Newsroom" },
      { id: "resources/contactus", name: "Contact Us" },
    ],
  },
  {
    topic: "Resources",
    links: [
      { id: "resources/blog", name: "Blog" },
      { id: "resources/casestudy", name: "Case studies" },
      { name: "Support" },
    ],
  },
];

export const servingdata = [
  {
    value: "250,000+",
    type: "Customers reached everyday with Paytm Cloud ",
  },
  {
    value: "225M+",
    type: "Hours of customer time consumed",
  },
  {
    value: "$40B+",
    type: "in sales processed for Paytm Cloud partners",
  },
];

export const experience = [
  {
    value: "23 yrs",
    type: "Experience",
  },
  {
    value: "20 Mn",
    type: "MAUs",
  },
  {
    value: "35",
    type: "Countries",
  },
  {
    value: "500hrs",
    type: "Total Daily Time spent by users",
  },
];

export const features = [
  "Improved call handling efficiency",
  "Cost saving",
  "Enhanced customer experience",
  "Real-time monitoring and reporting",
  "Increase Productivity",
  "Scalability",
  "Enhanced Customer Satisfaction",
  "Improved call Quality",
  "Reliable Up time",
  "User friendly DIY",
];

export const ourChannels = [
  {
    id: "sms",
    image: sms,
    title: "SMS",
    description: "Short message service (SMS) is a text messaging service.",
  },
  {
    id: "googlercs",
    image: googleRCS,
    title: "Google RCS",
    description:
      "Rich Communication Services is a advanced messaging protocol.",
  },
  {
    id: "whatsapp",
    image: whatsApp,
    title: "WhatsApp",
    description:
      "WhatsApp is a messaging app that allows users to send text messages.",
  },
  {
    id: "email",
    image: email,
    title: "Email",
    description:
      "Twitter DMs are private messages sent between two Twitter users.",
  },
  {
    id: "voiceapis",
    image: voiceAPIs,
    title: "Voice APIs",
    description:
      "Voice API refers to a set of tools and protocols used by developers.",
  },
  {
    id: "contactus",
    title: "Contact Us",
    description: "How to get help from the Paytm Cloud team, post a question.",
  },
];

export const ourSolution = [
  {
    id: "bfsi",
    image: BFSI,
    title: "BFSI",
    description:
      "Financial institution that offers various services, such as deposits, and loans.",
  },
  {
    id: "hospitality",
    image: Hospitality,
    title: "Hospitality",
    description:
      "Industry that focuses on providing services & accommodations.",
  },
  {
    id: "dthentertainment",
    image: dthEntertainment,
    title: "DTH & Entertainment",
    description: "Activities or performances that provide enjoyment.",
  },
  {
    id: "retail",
    image: retail,
    title: "Retail",
    description:
      "The sale of goods or merchandise to consumers through physical or online.",
  },
  {
    id: "realestate",
    image: realestate,
    title: "Real Estate",
    description:
      "Industry focused on providing medical and health-related services.",
  },
  {
    id: "education",
    image: education,
    title: "Education",
    description:
      "The process of acquiring knowledge & skills through teaching, learning.",
  },
  {
    id: "contactus",
    title: "Contact Us",
    description: "How to get help from the Paytm Cloud team, post a question.",
  },
];

export const caseStudy = [
  {
    id: "caseStudy01",
    image: caseStudy01,
    title: "Hindware Loyalty",
    filePath: hindware_CaseStudy,
    description: "How Paytm Rewardz loyalty helped Hindware increase sales",
  },
  {
    id: "caseStudy02",
    image: caseStudy02,
    title: "Lenskart Tocom",
    filePath: lenskart_CaseStudy,
    description: "How Tocom helped Lenskart to send 5.5 cr messages per month",
  },
  {
    id: "caseStudy03",
    image: caseStudy03,
    title: "Creditmate",
    filePath: credimate_CaseStudy,
    description:
      "How Paytm Cloud solutions helped Creditmate to increase agent productivity",
  },
  {
    id: "caseStudy04",
    image: caseStudy03,
    title: "HRMS",
    filePath: hrms_CaseStudy,
    description:
      "How Paytm HRMS reduced manual effort increase employee engagement",
  },
];
export const comments = [
  {
    rating: 5,
    comment:
      "We'll put a happy little sky in here. Now we'll take the almighty fan brush. Everybody needs a friend. The man who does the best job is the one who is happy at his job. Nothing wrong with washing your brush.",
    name: "Poonam Chandra",
    designation: "Art direction & Design, Paytm",
    pic: null,
  },
  {
    rating: 4,
    comment:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Amet volutpat consequat mauris nunc congue nisi vitae. Tincidunt vitae semper quis lectus nulla.",
    name: "John Doe",
    designation: "Designation & Company Name",
    pic: null,
  },
  {
    rating: 3,
    comment:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Amet volutpat consequat mauris nunc congue nisi vitae. Tincidunt vitae semper quis lectus nulla.",
    name: "Jane Doe",
    designation: "Designation & Company Name",
    pic: null,
  },
  {
    rating: 4,
    comment:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Amet volutpat consequat mauris nunc congue nisi vitae. Tincidunt vitae semper quis lectus nulla.",
    name: "John Doe",
    designation: "Designation & Company Name",
    pic: null,
  },
];

export const platforms = [
  {
    image: loyalty,
    title: "Loyalty",
    url: LOYALTY_URL,
    description:
      "A great feature of Paytm is its loyalty program, which allows you to reward your customers for their loyalty & engagement.",
  },
  {
    image: tocom,
    title: "Tocom",
    url: TOCOM_URL,
    description:
      "One of the key advantages of using Paytm for your marketing needs is the ability to create targeted campaigns.",
  },
  {
    image: customer_connect,
    title: "Customer Connect",
    url: CLOUD_TELEPHONY_URL,
    description:
      "In addition to its marketing capabilities, Paytm also offers a range of call centre solutions that can help manage businesses.",
  },
  {
    image: hrms,
    title: "HRMS",
    url: HRMS_URL,
    description:
      "A great feature of Paytm is its loyalty program, which allows you to reward your customers for their loyalty & engagement.",
  },
];

export const resourcesconst = [
  {
    id: "blog",
    title: "Blog",
    description: "Online writing platform for sharing ideas & experiences.",
  },
  {
    id: "newsletter",
    title: "Newsletter",
    description:
      "Regularly distributed digital publication providing updates & information.",
  },
  {
    id: "casestudy",
    title: "Case Studies",
    description:
      "In-depth analysis of a particular situation, event & proposing solutions.",
  },
  {
    id: "ebook",
    title: "Ebook",
    description:
      "In-depth analysis of a particular situation, event & proposing solutions.",
  },
  {
    id: "videos",
    title: "Videos",
    description:
      "Audio-visual medium for entertainment, & educational purposes.",
  },
  {
    id: "webinars",
    title: "Webinar",
    description:
      "Live, interactive online seminar or workshop on a specific topic or subject.",
  },
  {
    id: "contactus",
    title: "Contact Us",
    description: "How to get help from the Paytm Cloud team, post a question.",
  },
];

export const videos = [
  {
    id: "v1",
    image: thumbnail,
    title: "Video title-1 goes here",
    subText: "Subtitle text",
    hours: "2.5 total hours",
  },
  {
    id: "v2",
    image: thumbnail,
    title: "Video title-2 goes here",
    subText: "Subtitle text",
    hours: "2.5 total hours",
  },
  {
    id: "v3",
    image: thumbnail,
    title: "Video title-3 goes here",
    subText: "Subtitle text",
    hours: "2.5 total hours",
  },
  {
    id: "v4",
    image: thumbnail,
    title: "Video title-4 goes here",
    subText: "Subtitle text",
    hours: "2.5 total hours",
  },
  {
    id: "v5",
    image: thumbnail,
    title: "Video title-5",
    subText: "Subtitle text",
    hours: "2.5 total hours",
  },
];

export const voiceAPIsData = [
  {
    id: "1",
    title: "Feature title 1",
    description:
      "Voice API refers to a set of tools and protocols used by developers to integrate voice-based functionality, such as text-to-speech and speech-to-text, into their applications or services.",
    children: [
      {
        id: "101",
        title: "Sub-feature title 1",
        description:
          "Voice API refers to a set of tools and protocols used by developers to integrate voice-based functionality, such as text-to-speech and speech-to-text, into their applications or services.",
      },
      {
        id: "102",
        title: "Sub-feature title 2",
        description:
          "Voice API refers to a set of tools and protocols used by developers to integrate voice-based functionality, such as text-to-speech and speech-to-text, into their applications or services.",
      },
    ],
  },
  {
    id: "2",
    title: "Feature title 2",
    description:
      "Voice API refers to a set of tools and protocols used by developers to integrate voice-based functionality, such as text-to-speech and speech-to-text, into their applications or services.",
    children: [
      {
        id: "201",
        title: "Sub-feature title 1",
        description:
          "Voice API refers to a set of tools and protocols used by developers to integrate voice-based functionality, such as text-to-speech and speech-to-text, into their applications or services.",
      },
      {
        id: "202",
        title: "Sub-feature title 2",
        description:
          "Voice API refers to a set of tools and protocols used by developers to integrate voice-based functionality, such as text-to-speech and speech-to-text, into their applications or services.",
      },
    ],
  },
];

export const yearsGrowthdata = [
  { year: 2021, points: ["Equity Trading", "Smart POS", "Derivatives/ F&O"] },
  {
    year: 2020,
    points: [
      "Soundbox",
      "BNPL 2.0",
      "Insurance Broking",
      "All in One QR",
      "All in One Gateway",
      "All in One Android POS",
      "Credit Card",
    ],
  },
  { year: 2019, points: ["BNPL", "Merchant Cash Advance"] },
  { year: 2018, points: ["Paypay", "Paytm Money", "Paytm First Gam"] },
  {
    year: 2017,
    points: [
      "Paytm UPI",
      "Insurance Attachment",
      "Paytm Payments Bank",
      "Paytm Gold, FASTag",
      "Events Ticketing",
    ],
  },
  { year: 2016, points: ["Train Ticketing", "Flight Ticketing"] },
  { year: 2015, points: ["Bill Payments", "Movie Ticketing", "QR Codes"] },
  { year: 2014, points: ["Bus Ticketing", "Paytm Wallet"] },
  { year: 2012, points: ["Payment Gateway"] },
  { year: 2009, points: ["Launch of Paytm"] },
];

export const healthcaredata = [
  {
    id: 1,
    title: "Problem 1 title",
    description:
      "A problem can range from simple to complex, and may require critical thinking, analysis, and creativity to solve.",
    children: [
      {
        id: 101,
        title: "Solution type 1 title",
        description:
          "A solution is an answer or resolution to a problem or challenge, often requiring careful analysis, planning, and implementation.",
      },
      {
        id: 102,
        title: "Solution type 2 title",
        description:
          "A solution is an answer or resolution to a problem or challenge, often requiring careful analysis, planning, and implementation.",
      },
    ],
  },

  {
    id: 2,
    title: "Problem 2 title",
    description:
      "A problem can range from simple to complex, and may require critical thinking, analysis, and creativity to solve.",
    children: [
      {
        id: 201,
        title: "Solution type 1 title",
        description:
          "A solution is an answer or resolution to a problem or challenge, often requiring careful analysis, planning, and implementation.",
      },
    ],
  },
];

export const faq = [
  {
    ques: "What is an outbound call center?",
    ans: "Outbound call centers ensure managing outgoing calls to potential customers and buyers. SMBs, start-ups, and enterprises engage with outbound call center firms to reach out to a targeted list of consumers, through calls, SMS, and emails. Based on the key objectives of the outreach campaign, the right outbound contact center solutions can be leveraged to gain more sales or receive customer feedback.",
  },
  {
    ques: "Which dialers are available with Cloud Telephony's Outbound Call Centre Solution?",
    ans: "There are four types of dialers available, Predictive, Progressive, Click2Call and Manual Dialer.",
  },
  {
    ques: "What is an Inbound call center?",
    ans: "Inbound call centers manage incoming communication to an organization, in terms of calls, texts, emails, and live chat queries. A robust inbound contact center software is leveraged to handle the quantities of incoming calls, and to facilitate easy routing of all calls to the right agent. All questions can then easily be answered by the agent on-call, thereby resolving queries quickly. Inbound call center services ensure effective query resolution and brand building to new customers across portfolios. Inbound call center solutions focus on agent availability and effective call routing. They are designed to streamline the incoming call experience, through key solutions such as call whispering, barging, mobile apps, and CRM integration.",
  },
  {
    ques: "What is campaign management in Tocom?",
    ans: "A campaign management system helps business administrators create and manage all promotional offers, campaigns, and more. It includes analytics and reports to enable customer segmenting to create targeted and contextual offerings.",
  },
  {
    ques: "What does Tocom Campaign Management do?",
    ans: "Tocom Campaign manager allows multi-channel communication to improve the customer experience and drive better relationships across all possible channels and touchpoints via SMS, Email, Voice, Push Notification for app and web, RCS and WhatsApp. It also offers real-time insights and performance monitoring of a particular campaign for predictive analysis & churn prevention.",
  },
  {
    ques: "Who is the service intended for?",
    ans: "Tocom enables SMS/Email/WhatsApp/Voice messaging/Push Notifications for app and web to all the B2C or B2B service providers (called Campaign Service Providers or CSPs) to register for Marketing or general Campaigns on behalf of the Brands they work with. After registering a Campaign on Tocom, business administrators work with their connectivity partners to activate the Campaign and send messages/notifications to end users.",
  },
  {
    ques: "What is PrideStaff HRMS?",
    ans: "PrideStaff HRMS is an affirmative action's HRMS solutions platform that has been serving clients as a unified source to tough HR Problems. Business-driven and people-focused, our HRMS platform offers pragmatic, professional & progressive services right from acquiring the required skill to managing end-to-end HR operations.",
  },
  {
    ques: "Is your system scalable?",
    ans: "Yes, our system is scalable. It can manage terabytes of data. Our HRMS is capable of scaling without changing the database.",
  },
  {
    ques: "Does the company provide any training to the employees and management after implementation of your system?",
    ans: "Yes, we do provide training to the employees and admin so that they can understand and use our system accurately.",
  },
  {
    ques: "What is a loyalty rewards platform?",
    ans: "A loyalty rewards platform is the backend system or software that controls all aspects of a loyalty program like customer contact information, points earned/redeemed, point expiry criteria, type of rewards/offers, membership tiers, etc.",
  },
  {
    ques: "Do loyalty programs increase sales?",
    ans: "Loyalty programs can generate significant growth in recurring revenue for your business.",
  },
  {
    ques: "How does loyalty programs help businesses?",
    ans: "A critical and often overlooked benefit of loyalty programs is their ability to reduce customer acquisition costs. This is especially true for Ecommerce businesses where high acquisition costs have caused several brands to incur heavy losses. Loyalty programs can boost customer retention as well as maximize their revenue contribution through repeat sales and higher Average Basket Value.",
  },
];

export const bfsiPSdata = [
  {
    id: "bfsi01",
    title: "1. Lack of awareness causing issues with customer management",
    description: `
    <ol>
      <li><strong>Increasing Competition</strong>: FinTechs are diverting a significant portion of annual revenue from traditional financial services companies by targeting profitable areas.</li>
      <li><strong>Lack of Awareness</strong>: BFSI companies are losing loyal customers to new players despite providing various services.</li>
      <li><strong>Customer Management</strong>: Managing a large customer base is challenging, and a lack of expertise in customer support and grievance management is costly.</li>
    </ol>
  `,
    children: [
      {
        id: "bfsisol101",
        title: "Solution",
        image: BFSI01,
        description: `
        <ol>
          <li>Offering Outbound Dialing Services to reach the audience and provide quality banking and insurance-related services through outbound calling.</li>
          <li>Enhancing Customer Support (Inbound Calling) to improve customer experience and thrive in the competitive market.</li>
          <li>Sending Informative Calls to increase trust-building among new customers by sharing information about products and services.</li>
        </ol>`,
      },
    ],
  },
  {
    id: "bfsi02",
    title: "2. Complex interface while handling large customer database",
    description: `
    <ul>
      <li>In the BFSI industry, the main challenges involve a complex interface for handling a large customer database, making personalized experiences difficult.</li>
      </ul>
      `,
    children: [
      {
        id: "bfsisol201",
        title: "Solution",
        image: BFSI02,
        description:
          "<p>With TOCOM Campaign Management, we offer an easy-to-use DIY platform for marketing automation, simplifying SMS, Voice, and Email marketing campaigns to enhance customer experiences.</p>",
      },
    ],
  },
  {
    id: "bfsi03",
    title: "3. Lack of centralized database",
    description: `
    <ol>
      <li>Lack of a centralized employee database</li>
      <li>Difficulty in performance tracking, reimbursements, claims, payroll, taxes, appraisals, attendance, leave management, training, and development.</li>
      </ol>`,
    children: [
      {
        id: "bfsisol301",
        title: "Solution",
        image: BFSI03,
        description: `
        <ol>
          <li>Our HRMS system provides consolidated and error-free data for accurate payroll and improved employee satisfaction.</li>
          <li>Providing automated payroll leading to timely and error-free pay slips, ensuring happy employees.</li>
          <li>Enabling a Self-service portal for easy communication and connectivity for remote employees.</li>
          <li>Provides a Transparent and authentic performance management system (PMS) for better talent management and appraisals.</li>
          <li>Provides Intuitive dashboards with insightful data for recognizing high performance and Creating career pathways.</li>
          <li>Our HRMS system facilitates easy access to training programs and webinars from any device to streamline assessment and certification processes.</li>
          </ol>`,
      },
    ],
  },
  {
    id: "bfsi04",
    title: "4. Reporting issues regarding monetary entries.",
    description: `
    <ul>
      <li>In the BFSI Industry, the major challenges involve reporting issues with monetary entries and accurate data/reports on transactions and deposits.</li>
    </ul>`,
    children: [
      {
        id: "bfsisol401",
        title: "Solution",
        image: BFSI04,
        description: `
        <ol>
          <li>Our Loyalty program addresses these challenges by creating and maintaining accurate MIS. It includes points earning and burning for users/patients, automated Apps, and microsites for patient loyalty programs.</li>
          <li>We also offer tier-based segment classification (bronze, silver, gold, platinum) and provide MIS reports based on customer activity and engagement.</li>
        </ol>`,
      },
    ],
  },
];

export const educationPSdata = [
  {
    id: "educationP01",
    title: "1. Lack of personalized attention and missing leads.",
    description: `
    <ol>
      <li>Lack of personalized attention and missed leads from students searching for courses and career paths.</li> 
      <li>Issues with course registration and enrollment assistance services, leading to unanswered queries.</li>   
    </ol>`,
    children: [
      {
        id: "educationsol101",
        title: "Solution",
        image: education01,
        description: `
        <ol>
          <li>Ensuring better handling of missed leads, and providing the right guidance to students.</li> 
          <li>Improving course registration and enrollment assistance services for personalized attention to queries.</li>  
        </ol>`,
      },
    ],
  },
  {
    id: "educationP02",
    title: "2. Less engagement and hign competition.",
    description: `
    <ol>
      <li>Less engagement due to a traditional approach in online classes.</li> 
      <li>Competition to stand out among top education service providers.</li>   
    </ol>`,
    children: [
      {
        id: "educationsol201",
        title: "Solution",
        image: education02,
        description: `
        <ol>
          <li>Tocom provides more interactive and engaging campaigns according to the latest trends.</li> 
          <li>Tocom uses interactive ways and educational resources to resolve marketing issues.</li>  
          <li>Tocom shares informative notifications/messages like free online classes, scholarship offers, and new batch updates via Text, WhatsApp, Emails, and RCS in bulk to ease processes for educators.</li>  
        </ol>`,
      },
    ],
  },
  {
    id: "educationP03",
    title: "3. Endless paperwork, Training and Performance Management.",
    description: `
    <ol>
      <li>Endless paperwork</li> 
      <li>Tracking student's and employee's performance</li>  
      <li>Lack of seamless communication</li> 
      <li>Lack of training and development options</li>
      <li>Acquiring the right talent</li>
      <li>Maintaining and tracking records</li>
    </ol>`,
    children: [
      {
        id: "educationsol301",
        title: "Solution",
        image: education03,
        description: `
        <ol>
          <li>Eliminating paperwork through a centralized database for space and cost savings.</li> 
          <li>Effective Learning Management System for planning training and learning sessions, providing learning materials and conducting assessments.</li>  
          <li>Attendance Management to automate attendance tracking and reduce manual efforts.</li> 
          <li>Leave Management with easy leave application, approval, and tracking.</li>
          <li>Performance Management to assess student's and employee's performance through KRA's, objectives, and feedback processes.</li>
        </ol>`,
      },
    ],
  },
  {
    id: "educationP04",
    title: "4. Ambivalent point distribution in loyalty programs",
    description: `
    <p><strong>Before jumping into an education loyalty program, here are a few considerations:</strong></p>
    <ol>
      <li>Evaluate if it aligns with your sales cycle and encourages customer retention.</li> 
      <li>Ensure it complements your marketing strategy through thorough research and planning.</li>  
      <li>Consider implementing a Point-Based Program for engaging loyalty with low operational costs and redeemable points for repeat visits and coupon transfers.</li> 
      <li>Reward all stakeholders, including students, teachers, and parents, with incentives such as college tuition, sports accessories, gift cards, and more based on their roles and interests.</li>  
    </ol>`,
    children: [
      {
        id: "educationsol401",
        title: "Solution",
        image: education04,
        description: `
        <p><strong>An education loyalty program with clear point distribution removes ambiguity and boosts engagement. It attracts top talent, enhances reputation, and increases revenue</strong></p>
        <ol>
          <li>Our Loyalty Program attracts the best talent and enhances the institution's reputation through a loyalty program</li> 
          <li>Our Loyalty Program Boosts engagement and retaining students through gamification modules like quizzes, surveys, video games, and more.</li>  
          <li>Our Loyalty Program indulges in increasing revenue by offering attractive coupons and discounts.</li> 
          <li>Our Loyalty Program Implements a classification of tier-based segment programs for students (bronze, silver, gold, and platinum plans).</li>  
        </ol>`,
      },
    ],
  },
];

export const retailPSdata = [
  {
    id: "retailP01",
    title:
      "1. Absence of specialized loyalty-based programmes, Price competition and Customization trends.",
    description: `
    <ol>
      <li><strong>Absence of Specialized Loyalty-Based Programs</strong>: The lack of tailored loyalty initiatives hinders customer retention and relationships.</li>
      <li><strong>Price Competition</strong>: Intense competition leads to aggressive pricing without sacrificing profits.</li>
      <li><strong>Customization Trend</strong>: Meeting the demand for personalized products and experiences is a significant challenge.</li>
      <li><strong>Lack of Loyalty Programs</strong>: Implementing effective loyalty programs that resonate with customers remains a struggle.</li>
    </ol>
    `,
    children: [
      {
        id: "retailsol101",
        title: "Solution",
        image: retail01,
        description: `
        <ol>
          <li><strong>Cost Efficiency and Productivity</strong>: Improved solutions reduce input costs, leading to better returns and increased productivity.</li>
          <li><strong>Customer-Centric Panel</strong>: Empowering users with a customizable panel enhances user experience and fosters a sense of exclusivity.</li>
          <li><strong>Personalized Engagement</strong>: Informative calls and messages based on customer preferences attract a broader consumer base.</li>
        </ol>
        `,
      },
    ],
  },
  {
    id: "retailP02",
    title: "2. Poor marketing leading to business failure.",
    description: `
    <ul>
      <li>In a highly competitive world, inadequate marketing strategies can lead to business failure. Retailers, playing a crucial role between producers and consumers, face obstacles in promoting their products. Regrettably, 14% of small retail businesses fail due to poor marketing, including insufficient communication with customers about product updates, pricing, and introductory offers.</li>
    </ul>
    `,
    children: [
      {
        id: "retailsol201",
        title: "Solution",
        image: retail02,
        description: `
        <p>
        Modern marketing requires businesses to engage customers across multiple channels for the perfect customer experience. Tocom enables omni-channel engagement, allowing personalized brand promotions through custom Emails, SMS, Whatsapp, Voice, App Push, and Web push channels.
        </p>
        `,
      },
    ],
  },
  {
    id: "retailP03",
    title: "3. Issues with performance tracking and Learning and Development.",
    description: `
    <ol>
      <li>Advanced Timekeeping</li>
      <li>Data Accuracy</li>
      <li>Performance Tracking</li>
      <li>Multiple Stakeholders</li>
      <li>Training and Development Opportunities</li>
      <li>Robust Employee Training and Engagement</li>
    </ol>
    `,
    children: [
      {
        id: "retailsol301",
        title: "Solution",
        image: retail03,
        description: `
        <ol>
          <li>Prioritize employee growth with flexible learning options tailored to individual needs.</li>
          <li>Quickly onboard new hires using automated HR policies for a smooth integration process.</li>
          <li>Monitor progress through detailed dashboards, course reports, and surveys.</li>
          <li>Encourage growth with frequent performance discussions and 1:1 interactions.</li>
          <li>Optimize scheduling with flexible shifts, accounting for employee availability and foot traffic changes.</li>
          <li> Access on-demand intelligence for operational efficiency, cost management, and staff productivity.</li>
          <li>Accurately manage attendance, timesheets, and working shifts for increased efficiency.</li>
          <li>Implement learning styles suited to employees' preferences with customizable courses and easy progress tracking.</li>
          <li>With our HRMS system, enhance employee satisfaction, streamline training programs, and manage staffing and business metrics effectively.</li>
          <li>Enhancing Employee Retention and Development.</li>
        </ol>
        `,
      },
    ],
  },
  {
    id: "retailP04",
    title: "4. Addressing Mundane Tasks and Employee Retention",
    description: `
    <ol>
      <li><strong>Customization</strong>: Users seek personalized services and products, moving away from one-size-fits-all approaches.</li>
      <li><strong>Employee Retention</strong>: Retaining employees requires tackling repetitive work, unstimulating routines, lack of incentives, and inadequate training.</li>
      <li><strong>Balancing Human Resources and Technology</strong>: Achieving the right equilibrium between human capabilities and technological advancements is essential for organizational success.</li>
    </ol>
    `,
    children: [
      {
        id: "retailsol401",
        title: "Solution",
        image: retail04,
        description: `
        <ol>
          <li>Enhancing Customization and Employee Engagement.</li>
          <li><strong>Customization Trend</strong>: Embrace personalization for customer retention. Use CRM for personalized emails and SMS with special offers based on preferences.</li>
          <li><strong>Employee Engagement</strong>: Boost retention with employee discounts, team events, and individual sales goals. Our Agent management system rewards agents/retailers.</li>
          <li><strong>Balancing Technology and Human Interaction</strong>: Invest in technology while valuing human connection with customers for loyalty.</li>
        </ol>
        `,
      },
    ],
  },
];

export const hospitalityPSdata = [
  {
    id: "hospitalityP01",
    title: "1. Security and data handling issues",
    description: `
    <ol>
      <li><strong>Data Security</strong>: Ensuring data security is a significant challenge due to the sensitive personal information involved in this industry.</li>
      <li><strong>Changing Guest Expectations</strong>: Meeting evolving guest expectations is essential for the industry's growth and success.</li>
      <li><strong>Appointments and Reservations</strong>: Consumers often face issues with appointments and reservations, requiring efficient management and updates.</li>
    </ol>`,
    children: [
      {
        id: "hospitalitysol101",
        title: "Solution",
        image: hospitalityPSdata01,
        description: `
        <ol>
          <li><strong>Complete Data Masking</strong>: Ensure data privacy by displaying only compliant information to users, eliminating worries about data handling.</li>
          <li><strong>Easy Last-Minute Changes</strong>: Notify users about any changes through service messages or personalized calls, ensuring transparency in all interactions.</li>
          <li><strong>Reminders at Every Step</strong>: Offer users the option to receive reminder calls or messages to prevent missing any essential information.</li>
        </ol>`,
      },
    ],
  },
  {
    id: "hospitalityP02",
    title: "2. Customer Retention and Feedback",
    description: `
    <ul>
      <li>The industry faces hurdles in retaining customers and gathering valuable feedback, crucial for sustained success. Prioritizing retention and effective feedback mechanisms is essential for continuous service improvement.</li>
    </ul>`,
    children: [
      {
        id: "hospitalitysol201",
        title: "Solution",
        image: hospitalityPSdata02,
        description: `
        <p>Tocom offers a powerful marketing platform that enables businesses to reach a vast user base effortlessly. Leveraging our campaign manager services, including SMS, Voice, Email, WhatsApp, and Push notifications, administrators can efficiently run campaigns, enhancing brand presence and awareness for multiple businesses across the industry. Tocom's marketing solutions have created a strong impact, establishing a formidable brand reputation in the market.</p>`,
      },
    ],
  },
  {
    id: "hospitalityP03",
    title: "3. Uncertain policies resulting in lower productivity",
    description: `
    <ol>
      <li>Uncertain Policies Lowering Productivity</li>
      <li>Data Accuracy</li>
      <li>Performance Tracking</li>
      <li>Travel Requests Management</li>
      <li>Training and Development</li>
      <li>Reducing Manual Administration Tasks</li>
      <li>Unclear Travel Policies for Employees</li>
    </ol>`,
    children: [
      {
        id: "hospitalitysol301",
        title: "Solution",
        image: hospitalityPSdata03,
        description: `
        <ol>
          <li>Our HRMS travel management system allows employees to raise travel requests and monitor their status. Managers can also raise requests on behalf of employees.</li>
          <li>Travel requests are transparently monitored, and existing requests can be sorted quickly for efficient handling.</li>
          <li>Employees can define travel types, purposes, and dates for clear and organized requests.</li>
          <li>Provision to raise requests for the team, facilitating seamless travel coordination.</li>
          <li>Our HRMS system collects and analyzes data, providing error-free results for accurate payroll processing.</li>
          <li>A 360-degree feedback system ensures accurate performance measurement and fair appraisals, boosting productivity and morale.</li>
          <li>Our HRMS system helps admins create training programs for different departments, offering easy access to webinars, video tutorials, assessments, and certifications from any device.</li>
        </ol>`,
      },
    ],
  },
  {
    id: "hospitalityP04",
    title:
      "4. Operational problems and an inability to adapt to a changing market",
    description: `
    <ol>
      <li>Hospitality industry faces challenges in hiring and retaining competent staff, a common concern.</li>
      <li>Frequent shifts in advertising and marketing trends create issues for businesses to adapt.</li>
      <li>From reservations management to guest services and hotel maintenance, departments often fail to synchronize operations, leading to customer dissatisfaction and chaos.</li>
    </ol>`,
    children: [
      {
        id: "hospitalitysol401",
        title: "Solution",
        image: hospitalityPSdata04,
        description: `
        <ol>
          <li>Implementing a regular training module for the new workforce is crucial for retaining qualified staff.</li>
          <li>Utilize CRM and broadcasting modules to engage guests, keeping them informed about attractive and new services.</li>
          <li>Adopting an integrated hotel PMS system addresses front office problems and streamlines operations through automation, benefiting the property.</li>
        </ol>`,
      },
    ],
  },
];

export const realestatePSdata = [
  {
    id: "realestateP01",
    title:
      "1. Unable to reach the target audience with sales and marketing campaigns.",
    description: `
      <ol>
        <li>Inability to contact the target audience through sales and marketing initiatives.</li>
        <li>Improper sales and marketing affecting product/service success.</li>
        <li>Non-compliance calling leading to potential penalties.</li>
        <li>Difficulty reaching the audience with new deals or offers.</li>
      </ol>`,
    children: [
      {
        id: "realestatesol101",
        title: "Solution",
        image: realestate01,
        description: `
        <ol>
          <li>Time-constraint calling to comply with regulations and avoid compliance issues.</li>
          <li>Offer broadcasting to inform consumers about new launches and deals.</li>
          <li>Improved handling of customer queries for trust-building and lasting impressions.</li>
        </ol>`,
      },
    ],
  },
  {
    id: "realestateP02",
    title: "2. Unable to expand to a national or international level.",
    description: `
    <ul>
      <li>Unable to expand on a national or international level due to the need for extensive concept development and effective sales and marketing of residential units. Specific objectives include creating a multi-layered brand personality and growing international market awareness through top-tier media coverage.</li>
    </ul>`,
    children: [
      {
        id: "realestatesol201",
        title: "Solution",
        image: realestate02,
        description: `
        <p>
        Tocom enables advertising and running campaigns for designated user data in the real estate space through automation, including email marketing for engagement.
        </p>`,
      },
    ],
  },
  {
    id: "realestateP03",
    title: "3. Inaccuracy in data gathering and attracting the top talent.",
    description: `
    <ol>
      <li>Inaccuracy of gathered data.</li>
      <li>Broker and agent satisfaction.</li>
      <li>Attracting and retaining top talent.</li>
      <li>Lacking corporate training.</li>
      <li>Ensuring compliance.</li>
      <li>Data accuracy.</li>
      <li>Performance tracking.</li>
    </ol>`,
    children: [
      {
        id: "realestatesol301",
        title: "Solution",
        image: realestate03,
        description: `
        <ol>
          <li>Attractive benefits packages, retirement options, and perks to attract and retain top agents and staff.</li>
          <li>HR software with mobile support for recruiting and onboarding high-quality agents.</li>
          <li>HR software for compliance with labor laws and regulations, providing up-to-date information and support.</li>
          <li>HRMS system for accurate payroll and streamlined training and development programs.</li>
        </ol>`,
      },
    ],
  },
  {
    id: "realestateP04",
    title: "4. Business loyalty issues are preventing you from expanding.",
    description: `
    <ul>
      <li>Business loyalty issues hindering expansion in the real estate industry. Challenges include loyalty earning and burning points, impacting loyalty rewards for customers.</li>
    </ul>`,
    children: [
      {
        id: "realestatesol401",
        title: "Solution",
        image: realestate04,
        description: `
        <ol>
          <li>Providing communication channels to monitor clients' home values.</li>
          <li>Offering gift coupons, discounts, and cashback as affordable options for loyalty rewards.</li>
        </ol>`,
      },
    ],
  },
];

export const dthentertainmentPSdata = [
  {
    id: "dthentertainmentP01",
    title:
      "1. Concerned regarding data privacy and compliance rules and regulations",
    description: `
    <ol>
      <li><strong>Compliance with Laws/Regulations</strong>: Meeting regulatory requirements within stipulated time limits poses difficulties for the industry.</li>
      <li><strong>Data Privacy Concerns</strong>: Maintaining consumer trust is crucial, and the industry must guard against data leakages and compromise to third parties.</li>
      <li><strong>Lack of a Secured System</strong>: Ensuring data security is paramount, as unauthorized access to sensitive information poses a significant challenge that needs to be addressed.</li>
    </ol>`,
    children: [
      {
        id: "dthentertainmentsol101",
        title: "Solution",
        image: dthentertainmentsol01,
        description: `
        <ol>
          <li>Our system prioritizes data security, building trust among users by safeguarding data from external and internal threats.</li>
          <li>Ensuring compliance with the latest regulations establishes trust and reputation, enabling seamless communication with customers.</li>
          <li>Our system implements two-factor authentication, preventing unauthorized access and ensuring lawful use of the product.</li>
        </ol>`,
      },
    ],
  },
  {
    id: "dthentertainmentP02",
    title: "2. Lacking the means to attract and keep attention",
    description: `
    <ul>
      <li>Small brands are investing significantly in advertisements, leading to increased costs. Attention and retention of audience are major challenges as consumers have limited time and patience to engage with ads. To succeed, content must be appealing and targeted to a specific audience, requiring the use of specific tools and channels.</li>
    </ul>`,
    children: [
      {
        id: "dthentertainmentsol201",
        title: "Solution",
        image: dthentertainmentsol02,
        description: `
        <p>Marketing for media and entertainment businesses has evolved significantly over the years, necessitating the adoption of new strategies and techniques. Keeping users updated about every new content on the platform is crucial for engagement. Users appreciate being notified about new content, increasing the likelihood of viewing. With Tocom, channel-wise campaign creation is enabled, allowing marketers to use various mediums such as Push Notifications, Email, SMS, Voice, and Whatsapp to deliver messages and actions. Marketers can easily schedule and send campaigns based on their requirements, using Tocom's user-friendly panel with the option to schedule future campaigns for convenience.</p>`,
      },
    ],
  },
  {
    id: "dthentertainmentP03",
    title:
      "3. Problems with communication hinder effective instruction and overall growth.",
    description: `
    <ol>
      <li>Attracting New Talent</li>
      <li>Training and Development</li>
      <li>Data Accuracy</li>
      <li>Performance tracking</li>
      <li>Lack of Seamless Communication</li>
    </ol>`,
    children: [
      {
        id: "dthentertainmentsol301",
        title: "Solution",
        image: dthentertainmentsol03,
        description: `
        <ol>
          <li>Our HRMS system ensures accurate and error-free data collection for performing precise payroll calculations through automated mechanisms.</li>
          <li>Technology facilitates easy communication, even for remote employees, breaking barriers of distance and enabling connectivity through the self-service portal.</li>
          <li>An honest and transparent PMS improves HR productivity and employee morale. The system's 360-degree feedback ability provides accurate performance measures for fair appraisals.</li>
          <li>The HRMS system efficiently manages sporadic shift work common in the media and entertainment industry, promoting employee engagement, fostering a culture of inclusion, and enhancing communication across the organization.</li>
        </ol>`,
      },
    ],
  },
  {
    id: "dthentertainmentP04",
    title: "4. Tools that are complicated and lack personalization",
    description: `
    <ol>
      <li>The industry faces challenges with complex AI tools and user interfaces, hindering ease of use and understanding.</li>
      <li>Personalization and algorithm-related issues impact the industry's ability to deliver tailored solutions to users.</li>
    </ol>`,
    children: [
      {
        id: "dthentertainmentsol401",
        title: "Solution",
        image: dthentertainmentsol04,
        description: `
        <ol>
          <li>Personalized Experience: We deliver personalized experiences throughout the customer journey with single customer profiles for a holistic view.</li>
          <li>Consistency Across Channels: Utilizing multiple channels, including social media like Instagram, Facebook, YouTube, and WhatsApp, ensures a consistent and personalized experience based on individual interests and interactions.</li>
        </ol>`,
      },
    ],
  },
];

export const COUNTRY_WITH_DIALCODES = [
  { dialCode: "+93", country: " Afghanistan" },
  { dialCode: "+355", country: "  Albania" },
  { dialCode: "+213 ", country: " Algeria" },
  { dialCode: "+1-684 ", country: " American Samoa" },
  { dialCode: "+376 ", country: " Andorra, Principality of" },
  { dialCode: "+244", country: "  Angola" },
  { dialCode: "+1-264 ", country: " Anguilla" },
  { dialCode: "+672 ", country: " Antarctica" },
  { dialCode: "+1-268", country: "  Antigua and Barbuda" },
  { dialCode: "+54  ", country: "Argentina" },
  { dialCode: "+374 ", country: " Armenia" },
  { dialCode: "+297 ", country: " Aruba" },
  { dialCode: "+61  ", country: "Australia" },
  { dialCode: "+43 ", country: " Austria" },
  {
    dialCode: "+994 ",
    country:
      " Azerbaijan or Azerbaidjan (Former Azerbaijan Soviet Socialist Republic) ",
  },
  { dialCode: "+1-242 ", country: " Bahamas, Commonwealth of The" },
  { dialCode: "+973 ", country: " Bahrain, Kingdom of (Former Dilmun)" },
  { dialCode: "+880 ", country: " Bangladesh (Former East Pakistan)" },
  { dialCode: "+1-246 ", country: " Barbados" },
  {
    dialCode: "+375",
    country:
      "   Belarus (Former Belorussian [Byelorussian] Soviet Socialist Republic)",
  },
  { dialCode: "+32 ", country: " Belgium" },
  { dialCode: "+501", country: "  Belize (Former British Honduras)" },
  { dialCode: "+229", country: "  Benin (Former Dahomey)" },
  { dialCode: "+1-441 ", country: " Bermuda" },
  { dialCode: "+975", country: "  Bhutan, Kingdom of" },
  { dialCode: "+591", country: "  Bolivia" },
  { dialCode: "+387", country: "  Bosnia and Herzegovina" },
  { dialCode: "+267", country: "  Botswana (Former Bechuanaland)" },
  { dialCode: "+55 ", country: " Brazil" },
  { dialCode: "+673", country: "  Brunei (Negara Brunei Darussalam)" },
  { dialCode: "+359", country: "  Bulgaria" },
  { dialCode: "+226", country: "  Burkina Faso (Former Upper Volta)" },
  { dialCode: "+257", country: "  Burundi (Former Urundi)" },
  {
    dialCode: "+855",
    country:
      "  Cambodia, Kingdom of (Former Khmer Republic, Kampuchea Republic) ",
  },
  { dialCode: "+237", country: "  Cameroon (Former French Cameroon)" },
  { dialCode: "+1", country: "  Canada" },
  { dialCode: "+238", country: "  Cape Verde" },
  { dialCode: "+1-345", country: "  Cayman Islands" },
  { dialCode: "+236", country: "  Central African Republic" },
  { dialCode: "+235", country: "  Chad" },
  { dialCode: "+56 ", country: " Chile" },
  { dialCode: "+86 ", country: " China" },
  { dialCode: "+53 ", country: " Christmas Island" },
  { dialCode: "+61 ", country: " Cocos (Keeling) Islands" },
  { dialCode: "+57 ", country: " Colombia" },
  { dialCode: "+269", country: "  Comoros, Union of the" },
  {
    dialCode: "+243",
    country: "  Congo, Democratic Republic of the (Former Zaire) ",
  },
  { dialCode: "+242", country: "  Congo, Republic of the" },
  { dialCode: "+682", country: "  Cook Islands (Former Harvey Islands)" },
  { dialCode: "+506", country: "  Costa Rica" },
  { dialCode: "+225", country: "  Cote D'Ivoire (Former Ivory Coast)" },
  { dialCode: "+385", country: "  Croatia (Hrvatska)" },
  { dialCode: "+53 ", country: " Cuba" },
  { dialCode: "+357", country: "  Cyprus" },
  { dialCode: "+420", country: "  Czech Republic" },
  { dialCode: "+45 ", country: " Denmark" },
  {
    dialCode: "+253",
    country:
      " Djibouti (Former French Territory of the Afars and Issas, French Somaliland)",
  },
  { dialCode: "+1-767", country: "  Dominica" },
  { dialCode: "+1-809 ", country: " Dominican Republic" },
  { dialCode: "+670 ", country: " East Timor (Former Portuguese Timor)" },
  { dialCode: "+593 ", country: " Ecuador" },
  {
    dialCode: "+20 ",
    country: "Egypt (Former United Arab Republic - with Syria) ",
  },
  { dialCode: "+503 ", country: " El Salvador" },
  { dialCode: "+240 ", country: " Equatorial Guinea (Former Spanish Guinea)" },
  {
    dialCode: "+291 ",
    country: "  Eritrea (Former Eritrea Autonomous Region in Ethiopia) ",
  },
  {
    dialCode: "+372 ",
    country: "  Estonia (Former Estonian Soviet Socialist Republic)",
  },
  {
    dialCode: "+251 ",
    country: " Ethiopia (Former Abyssinia, Italian East Africa) ",
  },
  { dialCode: "+500 ", country: " Falkland Islands (Islas Malvinas)" },
  { dialCode: "+298 ", country: " Faroe Islands" },
  { dialCode: "+679 ", country: " Fiji" },
  { dialCode: "+358 ", country: " Finland" },
  { dialCode: "+33  ", country: "France" },
  { dialCode: "+594 ", country: " French Guiana or French Guyana" },
  {
    dialCode: "+689 ",
    country: "  French Polynesia (Former French Colony of Oceania) ",
  },
  { dialCode: "+241 ", country: " Gabon (Gabonese Republic)" },
  { dialCode: "+220 ", country: " Gambia, The" },
  {
    dialCode: "+995 ",
    country: " Georgia (Former Georgian Soviet Socialist Republic)",
  },
  { dialCode: "+49  ", country: "Germany" },
  { dialCode: "+233 ", country: " Ghana (Former Gold Coast)" },
  { dialCode: "+350 ", country: " Gibraltar" },
  { dialCode: "+30  ", country: "Greece" },
  { dialCode: "+299 ", country: " Greenland" },
  { dialCode: "+1-473", country: "  Grenada" },
  { dialCode: "+590 ", country: " Guadeloupe" },
  { dialCode: "+1-671", country: "  Guam" },
  { dialCode: "+502", country: "  Guatemala" },
  { dialCode: "+224", country: "  Guinea (Former French Guinea)" },
  { dialCode: "+245", country: "  Guinea-Bissau (Former Portuguese Guinea)" },
  { dialCode: "+592", country: "  Guyana (Former British Guiana)" },
  { dialCode: "+509", country: "  Haiti" },
  { dialCode: "+504", country: "  Honduras" },
  { dialCode: "+852", country: "  Hong Kong" },
  { dialCode: "+36 ", country: " Hungary" },
  { dialCode: "+354", country: "  Iceland" },
  { dialCode: "+91 ", country: " India" },
  {
    dialCode: "+62 ",
    country: " Indonesia (Former Netherlands East Indies; Dutch East Indies) ",
  },
  { dialCode: "+98 ", country: " Iran, Islamic Republic of" },
  { dialCode: "+964", country: "  Iraq" },
  { dialCode: "+353", country: "  Ireland" },
  { dialCode: "+972", country: "  Israel" },
  { dialCode: "+39 ", country: " Italy" },
  { dialCode: "+1-876", country: "  Jamaica" },
  { dialCode: "+81 ", country: " Japan" },
  { dialCode: "+962", country: "  Jordan (Former Transjordan)" },
  {
    dialCode: "+7  ",
    country:
      "Kazakstan or Kazakhstan (Former Kazakh Soviet Socialist Republic) ",
  },
  { dialCode: "+254", country: "  Kenya (Former British East Africa)" },
  {
    dialCode: "+686",
    country: "  Kiribati (Pronounced keer-ree-bahss) (Former Gilbert Islands)",
  },
  {
    dialCode: "+850",
    country: " Korea, Democratic People's Republic of (North Korea) ",
  },
  { dialCode: "+82 ", country: " Korea, Republic of (South Korea)" },
  { dialCode: "+965", country: "  Kuwait" },
  {
    dialCode: "+996",
    country:
      "  Kyrgyzstan (Kyrgyz Republic) (Former Kirghiz Soviet Socialist Republic)",
  },
  { dialCode: "+856", country: "  Lao People's Democratic Republic (Laos)" },
  {
    dialCode: "+371",
    country: "  Latvia (Former Latvian Soviet Socialist Republic) ",
  },
  { dialCode: "+961", country: "  Lebanon" },
  { dialCode: "+266", country: "  Lesotho (Former Basutoland)" },
  { dialCode: "+231", country: "  Liberia" },
  { dialCode: "+218", country: "  Libya (Libyan Arab Jamahiriya)" },
  { dialCode: "+423", country: "  Liechtenstein" },
  {
    dialCode: "+370",
    country: "  Lithuania (Former Lithuanian Soviet Socialist Republic)",
  },
  { dialCode: "+352", country: "  Luxembourg" },
  { dialCode: "+853", country: "  Macau" },
  { dialCode: "+389", country: "  Macedonia, The Former Yugoslav Republic of" },
  { dialCode: "+261", country: "  Madagascar (Former Malagasy Republic)" },
  {
    dialCode: "+265",
    country:
      "  Malawi (Former British Central African Protectorate, Nyasaland) ",
  },
  { dialCode: "+60 ", country: " Malaysia" },
  { dialCode: "+960", country: "  Maldives" },
  {
    dialCode: "+223",
    country: "  Mali (Former French Sudan and Sudanese Republic)",
  },
  { dialCode: "+356", country: "  Malta" },
  {
    dialCode: "+692",
    country:
      "  Marshall Islands (Former Marshall Islands District - Trust Territory of the Pacific Islands) ",
  },
  { dialCode: "+596", country: "  Martinique (French)" },
  { dialCode: "+222", country: "  Mauritania" },
  { dialCode: "+230", country: "  Mauritius" },
  {
    dialCode: "+269",
    country: "  Mayotte (Territorial Collectivity of Mayotte)      ",
  },
  { dialCode: "+52 ", country: " Mexico" },
  {
    dialCode: "+691",
    country:
      "  Micronesia, Federated States of (Former Ponape, Truk, and Yap Districts- Trust Territory of the Pacific Islands)      ",
  },
  { dialCode: "+373", country: "  Moldova, Republic of" },
  { dialCode: "+377", country: "  Monaco, Principality of" },
  { dialCode: "+976", country: "  Mongolia (Former Outer Mongolia)" },
  { dialCode: "+1-664", country: "  Montserrat" },
  { dialCode: "+212", country: "  Morocco" },
  { dialCode: "+258", country: "  Mozambique (Former Portuguese East Africa)" },
  { dialCode: "+95 ", country: " Myanmar, Union of (Former Burma)" },
  {
    dialCode: "+264",
    country:
      "  Namibia (Former German Southwest Africa, South-West Africa)      ",
  },
  { dialCode: "+674", country: "  Nauru (Former Pleasant Island)" },
  { dialCode: "+977", country: "  Nepal" },
  { dialCode: "+31 ", country: " Netherlands" },
  {
    dialCode: "+599",
    country: "  Netherlands Antilles (Former Curacao and Dependencies)      ",
  },
  { dialCode: "+687", country: "  New Caledonia" },
  { dialCode: "+64 ", country: " New Zealand (Aotearoa)" },
  { dialCode: "+505", country: "  Nicaragua" },
  { dialCode: "+227", country: "  Niger" },
  { dialCode: "+234", country: "  Nigeria" },
  { dialCode: "+683", country: "  Niue (Former Savage Island)" },
  { dialCode: "+672", country: "  Norfolk Island" },
  {
    dialCode: "+1-670",
    country:
      "  Northern Mariana Islands (Former Mariana Islands District - TrustTerritory of the Pacific Islands)      ",
  },
  { dialCode: "+47  ", country: "Norway" },
  {
    dialCode: "+968 ",
    country: " Oman, Sultanate of (Former Muscat and Oman)",
  },
  { dialCode: "+92  ", country: "Pakistan (Former West Pakistan)" },
  {
    dialCode: "+680 ",
    country:
      " Palau (Former Palau District - Trust Terriroty of the Pacific Islands)      ",
  },
  { dialCode: "+970 ", country: " Palestinian State (Proposed)" },
  { dialCode: "+507 ", country: " Panama" },
  {
    dialCode: "+675 ",
    country:
      " Papua New Guinea (Former Territory of Papua and New Guinea)      ",
  },
  { dialCode: "+595 ", country: " Paraguay" },
  { dialCode: "+51  ", country: "Peru" },
  { dialCode: "+63  ", country: "Philippines" },
  { dialCode: "+48  ", country: "Poland" },
  { dialCode: "+351", country: "  Portugal" },
  { dialCode: "+1-787  ", country: "Puerto Rico" },
  { dialCode: "+974   ", country: "Qatar, State of" },
  { dialCode: "+262  ", country: "Reunion (French) (Former Bourbon Island)" },
  { dialCode: "+40 ", country: " Romania" },
  { dialCode: "+7  ", country: "Russian Federation" },
  { dialCode: "+250 ", country: " Rwanda (Rwandese Republic) (Former Ruanda)" },
  { dialCode: "+290 ", country: " Saint Helena" },
  {
    dialCode: "+1-869 ",
    country:
      " Saint Kitts and Nevis (Former Federation of Saint Christopher and Nevis)      ",
  },
  { dialCode: "+1-758 ", country: " Saint Lucia" },
  { dialCode: "+508  ", country: "Saint Pierre and Miquelon" },
  { dialCode: "+1-784", country: "  Saint Vincent and the Grenadines" },
  { dialCode: "+685", country: "  Samoa (Former Western Samoa)" },
  { dialCode: "+378", country: "  San Marino" },
  { dialCode: "+239", country: "  Sao Tome and Principe" },
  { dialCode: "+966", country: "  Saudi Arabia" },
  { dialCode: "+221", country: "  Senegal" },
  { dialCode: "+248", country: "  Seychelles" },
  { dialCode: "+232", country: "  Sierra Leone" },
  { dialCode: "+65 ", country: " Singapore" },
  { dialCode: "+421", country: "  Slovakia" },
  { dialCode: "+386", country: "  Slovenia" },
  {
    dialCode: "+677",
    country: "  Solomon Islands (Former British Solomon Islands)      ",
  },
  {
    dialCode: "+252",
    country:
      "  Somalia (Former Somali Republic, Somali Democratic Republic)      ",
  },
  { dialCode: "+27 ", country: " South Africa (Former Union of South Africa)" },
  { dialCode: "+34 ", country: " Spain" },
  { dialCode: "+94 ", country: " Sri Lanka (Former Serendib, Ceylon)" },
  { dialCode: "+249", country: "  Sudan (Former Anglo-Egyptian Sudan)" },
  {
    dialCode: "+597",
    country: "  Suriname (Former Netherlands Guiana, Dutch Guiana)      ",
  },
  { dialCode: "+268", country: "  Swaziland, Kingdom of" },
  { dialCode: "+46 ", country: " Sweden" },
  { dialCode: "+41 ", country: " Switzerland" },
  {
    dialCode: "+963",
    country:
      "  Syria (Syrian Arab Republic) (Former United Arab Republic - with Egypt)      ",
  },
  { dialCode: "+886", country: "  Taiwan (Former Formosa)" },
  {
    dialCode: "+992",
    country: "  Tajikistan (Former Tajik Soviet Socialist Republic)      ",
  },
  {
    dialCode: "+255",
    country:
      "  Tanzania, United Republic of (Former United Republic of Tanganyika andZanzibar)      ",
  },
  { dialCode: "+66  ", country: "Thailand (Former Siam)" },
  { dialCode: "+690  ", country: "Tokelau" },
  {
    dialCode: "+676  ",
    country: "Tonga, Kingdom of (Former Friendly Islands)",
  },
  { dialCode: "+1-868", country: "  Trinidad and Tobago" },
  { dialCode: "+216  ", country: "Tunisia" },
  { dialCode: "+90  ", country: "Turkey" },
  {
    dialCode: "+993  ",
    country: "Turkmenistan (Former Turkmen Soviet Socialist Republic)      ",
  },
  { dialCode: "+1-649", country: "  Turks and Caicos Islands" },
  { dialCode: "+688", country: "  Tuvalu (Former Ellice Islands)" },
  { dialCode: "+256", country: "  Uganda, Republic of" },
  {
    dialCode: "+380",
    country:
      "  Ukraine (Former Ukrainian National Republic, Ukrainian State, UkrainianSoviet Socialist Republic)      ",
  },
  {
    dialCode: "+971",
    country:
      "  United Arab Emirates (UAE) (Former Trucial Oman, Trucial States)      ",
  },
  { dialCode: "+44 ", country: " United Kingdom (Great Britain / UK)" },
  { dialCode: "+1  ", country: "United States" },
  {
    dialCode: "+598 ",
    country:
      " Uruguay, Oriental Republic of (Former Banda Oriental, CisplatineProvince)      ",
  },
  {
    dialCode: "+998 ",
    country: " Uzbekistan (Former UZbek Soviet Socialist Republic)      ",
  },
  { dialCode: "+678 ", country: " Vanuatu (Former New Hebrides)" },
  { dialCode: "+418 ", country: " Vatican City State (Holy See)" },
  { dialCode: "+58  ", country: "Venezuela" },
  { dialCode: "+84  ", country: "Vietnam" },
  { dialCode: "+1-284 ", country: " Virgin Islands, British" },
  {
    dialCode: "+1-340 ",
    country: " Virgin Islands, United States (Former Danish West Indies)      ",
  },
  { dialCode: "+681", country: "  Wallis and Futuna Islands" },
  { dialCode: "+967", country: "  Yemen" },
  {
    dialCode: "+260",
    country: "  Zambia, Republic of (Former Northern Rhodesia)      ",
  },
  {
    dialCode: "+263",
    country: "Zimbabwe, Republic of (Former Southern Rhodesia, Rhodesia)      ",
  },
];

export const smsdata = [
  {
    id: "smschannel01",
    title: "Engage Customers with text message marketing",
    image: SMS,
    description:
      "SMS campaigns, also known as text message marketing campaigns, are an effective and popular method for businesses to engage with their customers and promote their products or services. With the widespread use of mobile phones, Tocom SMS campaigns offers a direct and immediate way to reach a large audience for multiple businesses.",
  },
  {
    id: "smschannel02",
    title: "High Delivery rates",
    description:
      "With High Delivery rates, our SMS is one of the most effective engagement channels companies use to interact with their customers.Through SMS campaigns, make your marketing even more valuable for your customers and brands.",
  },
  {
    id: "smschannel03",
    title: "High open rate",
    description:
      "SMS campaigns have a high open rate, with studies showing that over 90% of text messages are read within minutes of being received.",
  },
  {
    id: "clientUseCases",
    description: `
      <div style="font-size:24px;font-weight:600;color:#0F172A;">Client Use Cases</div>
      <ol>
        <li>
          <div style="font-size:18px;font-weight:600;color:#0F172A;">Kapiva</div>
          <p>Leveraging SMS campaigns, Kapiva achieves an outstanding 85% conversion rate, utilizing the Tocom panel to effectively engage with its customer base. Sending an average of 3.2 Lakhs SMS per month, Kapiva ensures effective communication.</p>
        </li>
        <li>
          <div style="font-size:18px;font-weight:600;color:#0F172A;">IFFCO</div>
          <p>With a monthly SMS campaign of 2 Lakhs, IFFCO adeptly leverages the Tocom panel to foster enhanced customer engagement. This strategic approach allows IFFCO to efficiently share crucial updates and exclusive offers with its customers.</p>
        </li>
      </ol>
    `,
  },
];

export const googleRCSdata = [
  {
    id: "googleRCSdata01",
    title: "Most interactive marketing approach",
    image: googlercs,
    description:
      "RCS (Rich Communication Services) campaigns are an innovative and interactive marketing approach that takes advantage of the advanced features offered by RCS messaging. RCS is an upgrade to traditional SMS messaging, enabling businesses to deliver enhanced multimedia content, interactive buttons, and rich branding experiences to their customers' devices.",
  },
  {
    id: "googleRCSdata02",
    title: "Engaged User Experience",
    description:
      "With Tocom RCS campaigns, businesses can create visually appealing and engaging messages that include images, videos, carousels, suggested replies, and interactive buttons.",
  },
  {
    id: "googleRCSdata03",
    title: "Increased customer response and conversion",
    description:
      "Tocom RCS campaigns enable businesses to personalize their messages based on customer data and preferences, allowing for more targeted and relevant communication. This personalized approach enhances the chances of customer response and conversion.",
  },
];

export const whatsAppData = [
  {
    id: "whatsAppData01",
    title: "Reaching out maximum customers",
    image: whatsapp,
    description:
      "Introducing WhatsApp campaign to reach out maximum users directly for your product marketing , customer services. This feature allows you to retarget a particular set of users by sending them a WhatsApp Broadcast Campaign with customized experience in building templates.",
  },
  {
    id: "whatsAppData02",
    title: "Sending customizing and personalized messages",
    description:
      "With billions of users worldwide, Tocom WhatsApp provides businesses with an opportunity to connect with customers in a direct and personalized manner. WhatsApp campaigns involve sending messages, images, videos, or links to opted-in subscribers, allowing businesses to promote products, provide customer support, share updates, or deliver exclusive offers.",
  },
  {
    id: "clientUseCaseswhatsApp",
    description: `
      <div style="font-size:24px;font-weight:600;color:#0F172A;">Client Use Cases</div>
      <ol>
        <li>
          <div style="font-size:18px;font-weight:600;color:#0F172A;">Repco Home Finance</div>
          <p>Repcohomefinance utilizes our platform to optimize its customer interactions, with our strategic WhatsApp campaigns effectively to convey financial solutions and opportunities and to run successful campaign.</p>
        </li>
        <li>
          <div style="font-size:18px;font-weight:600;color:#0F172A;">Pluslearning</div>
          <p>Plus Learning - Transforming education through WhatsApp campaigns, Plus Learning leverages this platform to enhance student engagement. With personalized messages and interactive content, our WhatsApp campaigns provide students with valuable learning resources and updates. By delivering educational content directly to their fingertips, we empower students to excel in their studies and stay informed about upcoming courses and events, fostering a seamless and enriching learning experience.</p>
        </li>
      </ol>
    `,
  },
];

export const emailData = [
  {
    id: "emaildata01",
    title: "Optimizing emails through A/B testing",
    image: emailchannels,
    description:
      "With an approach to target most of the audience at just a few steps and with a wide array of features that do everything from marketing automation to tracking tools to optimizing your emails through A/B testing.",
  },
  {
    id: "emaildata02",
    title: "Sharing valuable content through emails",
    description:
      "Businesses utilize email campaigns to build relationships with customers, promote products or services, share valuable content, and drive conversions.",
  },
  {
    id: "emaildata03",
    title: "Cost effective marketing",
    description:
      "With the ability to personalize messages, segment the audience, and track metrics like open rates and click-through rates, Tocom email campaigns offer a cost-effective and measurable way to engage with a large number of recipients.",
  },
  {
    id: "clientUseCasesEmail",
    description: `
      <div style="font-size:24px;font-weight:600;color:#0F172A;">Client Use Cases</div>
      <ol>
        <li>
          <div style="font-size:18px;font-weight:600;color:#0F172A;">Yellow Umbrella</div>
          <p>With a 80% conversion rate, Yellow umbrella utilizes TOCOM to engage effectively with its customers.</p>
        </li>
        <li>
          <div style="font-size:18px;font-weight:600;color:#0F172A;">Jainhousing</div>
          <p>Enriching connections via e-mail campaigns, Jainhousing employs a strategic approach to engage its audience. With tailored content and captivating visuals, our e-mail campaigns effectively showcase prime real estate offerings and investment prospects.</p>
        </li>
      </ol>
    `,
  },
];

export const voiceCampaignData = [
  {
    id: "voiceCampaignData01",
    title: "Mass communication campaign",
    image: voiceapis,
    description:
      "Voice campaigns are commonly used for promotional offers, event reminders, surveys, or political campaigns. While voice campaigns can be efficient for mass communication.",
  },
  {
    id: "voiceCampaignData02",
    title: "Voice out-dialed solutions",
    description:
      "Our high end voice out-dialed solutions enable brands to manage their communication effectively. With proactive dialing, it delivers efficient and effective campaigns. Outbound dialler calls are versatile and can be used for call blasts, client outreach and product marketing campaigns.",
  },
  {
    id: "voiceCampaignData03",
    title: "Clear opt options for engaging customers",
    description:
      "With Tocom Voice campaigns, businesses can do the proper targeting, and clear opt-out options for successful voice campaigns that engage and resonate with the recipients.",
  },
  {
    id: "clientUseCasesVoiceapis",
    description: `
      <div style="font-size:24px;font-weight:600;color:#0F172A;">Client Use Cases</div>
      <ol>
        <li>
          <div style="font-size:18px;font-weight:600;color:#0F172A;">Credit Mate</div>
          <p>Utilizing Voice channel campaigns, CreditMate maximizes customer engagement through the Tocom panel. With an average monthly distribution of 3.5 cr voice messages, CreditMate ensures timely delivery of important updates and offers.</p>
        </li>
        <li>
          <div style="font-size:18px;font-weight:600;color:#0F172A;">Paisabazar</div>
          <p>Enhancing engagement through Voice campaigns, PaisaBazar utilizes this dynamic channel to connect with its audience. With an average monthly distribution of 80 Lakhs voice messages, our strategic Voice campaigns ensure timely delivery of financial insights and exclusive offers.</p>
        </li>
      </ol>
    `,
  },
];

export const faqChannel = [
  {
    ques: "What is campaign management in Tocom?",
    ans: "A campaign management system, helps business’s administrators create and manage all promotional offers, campaigns, and more. It includes analytics and reports to enable customer segmenting to create targeted and contextual offerings.",
  },
  {
    ques: "What does Tocom Campaign Management do?",
    ans: "Tocom Campaign manager allows multi-channel communication to improve the customer experience and drive better relationships across all possible channels and touchpoints via SMS, Email, Voice,Push Notification for app and web, RCS and WhatsApp. It also offers real time insights and performance monitoring of a particular campaign for predictive analysis & churn prevention. ",
  },
  {
    ques: "Who is the service intended for?",
    ans: "Tocom enables SMS/Email/WhatsApp/Voice messaging/Push Notifications for app and web to all the B2C or B2B service providers (called Campaign Service Providers or CSPs) to register for Marketing or general Campaigns on behalf of the Brands they work with. After registering a Campaign on Tocom, business administrators work with their connectivity partners to activate the Campaign and send messages/notifications to end users",
  },
  {
    ques: "How do you campaign for an organization?",
    ans: "Step 1: Define the Goals\nStep 2:  Set the budget\nStep 3:  Determine the target audience\nStep 4:  Develop your messaging\nStep 5:  Decide the automation and functionality Criteria\nStep 6:  Run Campaign through Campaign Manager portal / Access will be given by administrator\nStep 7: Check Reports",
  },
];

export const offers = [
  "One-stop-shop for all your marketing needs.",
  "Robust platform and wide range of features for businesses of all sizes.",
  "Launching of marketing campaigns, implementation of HRMS system, managing your call center or setting up a loyalty program all these things at one place.",
];

export const standardfeatures = [
  "Live dashboard",
  "Auto Dialer",
  "Predictive dialer",
  "Progressive dialer",
  "Web RTC",
  "Call Recordings",
  "Report & Analytics",
  "Agent learning centre",
  "Agent performance management",
  "Closed user group chat",
];

export const prepaidPackages = [
  {
    plan: "Basic",
    planType:"Standard",
    amount: 2499,
    userslimit: "Basic features for up to <agentcount>",
    features: [
      "<storage> GB Recording space per month",
      "Reports scheduling <workflow>",
      "<agentchat> option for agents/supervisors",
      "<whatsapp> messages to customers",
      "<training> module for agents",
      // "<blank>",
      // "<blank>",
      // "<blank>",
      // "<blank>",
    ],
  },
  {
    plan: "SME Plan",
    planType:"Standard",
    amount: 5499,
    userslimit: "Growing Teams up to <agentcount>",
    features: [
      "<storage> GB Recording space per month",
      "Reports scheduling <workflow>",
      "<agentchat> option for agents/supervisors",
      "<whatsapp> messages to customers",
      "<training> module for agents",
      "External interation service",
      "Priority email service available",
      // "<blank>",
      // "<blank>",
    ],
  },
  {
    plan: "Enterprise Plan",
    planType:"Standard",
    amount: 9999,
    userslimit: "Advanced features + Unlimited users",
    features: [
      "<storage> GB Recording space per month",
      "Reports scheduling <workflow>",
      "<agentchat> option for agents/supervisors",
      "<whatsapp> messages to customers",
      "<training> module for agents",
      "External interation service",
      "Priority email service available",
      // "Personalised priority service",
      "Dedicatd Account Manager",
    ],
  },
];

